import { CardTransfer } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const CardTransferPage = ({ isCopy, isEdit }: IOperationPageProps) => (
  <CardTransfer isCopy={isCopy} isEdit={isEdit}/>
);
